import Vue from 'vue'
import { detectMobile } from "./VueMobileDetection";
Vue.prototype.$isMobile = detectMobile;